import { TERMINAL_FORM } from '../form-terminal-types';
import useAuth from '../../../../hooks/auth-hooks';
import { showToast } from '../../../toasts';
import { ITerminal } from '../../../../models/terminal.interface';
import { validateForm, getTerminalData } from '../from-terminal-helpers';

import { ITerminalInsertUpdate } from '../../../../models/terminal.interface';
import { awsUpdateTerminalIndividual } from '../../../../routes/update-terminal-individual';

/**
 * Function to update an individual terminal
 * 
 * @param {string} terminalID
 * 
 * @returns void
 */
export const updateTerminal = (terminalID: string, terminalData: ITerminal[]) => {
  if ( !TERMINAL_FORM.terminalFormUpdate ) return;
  
  const { 
    terminalFormUpdate, 
    terminalSubmitButton, 
    terminalName
  } = TERMINAL_FORM;

  const postUpdatedTerminal = async (awsData: ITerminalInsertUpdate) => {
    const { body } = await awsUpdateTerminalIndividual(awsData);

    if ( body ) {
      showToast('aafp_toast', `${terminalName.value} has been updated`);
      setTimeout(() => {
        location.href = '/terminals/';
      }, 2000);
    } else {
      showToast('aafp_toast-alert', `Error updating ${terminalName.value}`);
      terminalSubmitButton.classList.remove('aafp_button-loading');
    }
  };

  terminalFormUpdate.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    const { accessLevel } = useAuth()!;
    let elementList = [];

    if ( accessLevel === 'P' ) {
      elementList = [TERMINAL_FORM.terminalAddressState]
    } else {
      elementList = [TERMINAL_FORM.terminalAddressState, TERMINAL_FORM.terminalBillingType, TERMINAL_FORM.terminalStatus]
    }

    if( validateForm(terminalFormUpdate, elementList) ) {
      terminalFormUpdate.classList.remove('was-validated');
      terminalFormUpdate.classList.remove('form-control:valid');
      terminalSubmitButton.classList.add('aafp_button-loading');

      const awsModelData = getTerminalData(terminalID, terminalData, TERMINAL_FORM);
      postUpdatedTerminal(awsModelData);
    } 
  });
}